"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIconWrapper = exports.StyledItemsWrapper = void 0;
const ui_1 = require("@phishtool/ui");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledItemsWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledItemsWrapper", componentId: "sc-1my2oos" }) `
  display: flex;
  flex-wrap: wrap;

  ${(props) => (0, ui_1.mq)({
    columnGap: [props.theme.spacers.x3],
    rowGap: [props.theme.spacers.x6, null, props.theme.spacers.x12],
    width: ['100%', null, '80%'],
})}

  & > div {
    ${(0, ui_1.mq)({
    flex: ['100%', 'calc(50% - 18px)'],
})}
  }
`;
exports.StyledIconWrapper = styled_components_1.default.div.withConfig({ displayName: "StyledIconWrapper", componentId: "sc-6y78qv" }) `
  ${(0, ui_1.mq)({
    minWidth: ['82px', 'auto'],
})}
`;
